import { Component, Input } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import type { IconDef } from './icon';

@Component({
  selector: 'app-icon-reusable',
  standalone: true,
  imports: [],
  template: `
 <span
  [class]="'inline-flex items-center justify-center ' + computedClasses"
  [style.color]="color === 'currentColor' ? null : color"
  [innerHTML]="renderedSvg"
></span>
  `
})
export class IconComponent {
  constructor(private readonly sanitizer: DomSanitizer) {}

  @Input() icon: IconDef = {
    svg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v16H4z"/></svg>'
  };
  @Input() size: number = 16;
  @Input() width?: number;
  @Input() height?: number;
  @Input() color: string = 'currentColor';
  @Input() useCurrentColor: boolean = false;
  @Input() classes: string = '';
  @Input() variant: 'default' | 'badge-style' = 'default';

  get computedClasses(): string {
    const variantClasses =
      this.variant === 'badge-style' ? 'p-2 border border-slate200 rounded-full' : '';
    return `${variantClasses} ${this.classes}`.trim();
  }

  get renderedSvg(): SafeHtml {
    const width = this.width ?? this.size;
    const height = this.height ?? this.size;

    let svg = this.icon.svg
      .replace(/width="[^"]*"/, `width="${width}"`)
      .replace(/height="[^"]*"/, `height="${height}"`);

    if (this.useCurrentColor) {
      svg = svg
        .replace(/fill="(?!none)[^"]*"/g, 'fill="currentColor"')
        .replace(/stroke="(?!none)[^"]*"/g, 'stroke="currentColor"');
    }

    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
